import { commonTypes } from '../common';

export const types = {
};

export const initialState = {
};

const UINeedsMobileInsuranceReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.MOBILE_INSURANCE: {
      const { payload } = action;

      const { insurance } = payload;
      const {
        name,
        price,
        promo,
        promoPrice,
        modality,
        unity
      } = insurance;

      const newState = {
        ...state,
        deviceInfo: {
          ...state.deviceInfo,
          mobileInsurance: {
            ...state.deviceInfo.mobileInsurance,
            name,
            price,
            promo,
            promoPrice,
            modality,
            unity,
          },
        },
      };

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    default:
      return null;
  }
};

export const actions = {
};

export default UINeedsMobileInsuranceReducer;
